<div class="pcl-container">
  <div class="pcl-header">
    <h4 class="pcl-title">Player Character List</h4>
    <button type="button" class="pcl-close" aria-label="Close" (click)="closemodel()">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>

  <div class="pcl-table-wrap">
    <table class="pcl-table">
      <thead>
        <tr>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Nick Name</th>
          <th>Weight</th>
          <th>Alignment</th>
          <th>Strengths</th>
          <th>Weaknesses</th>
          <th>Primary Class</th>
          <th>Primary Class Level</th>
          <th>Secondary Class</th>
          <th>Secondary Class Level</th>
          <th>Race</th>
          <th>Intelligence</th>
          <th>Constitution</th>
          <th>Dexterity</th>
          <th>Strength</th>
          <th>Wisdom</th>
          <th>Charisma</th>
        </tr>
      </thead>
      <tbody>
        @for (player of playerListdata; track player) {
          <tr>
            <td>
              {{ player.first_name }}
              @if (player.game_details.length > 0) {
                <span class="pcl-badge">In Game</span>
              }
            </td>
            <td>{{ player.last_name }}</td>
            <td>{{ player.nick_name }}</td>
            <td>{{ player.weight }}</td>
            <td>{{ player.alignment }}</td>
            <td>{{ player.strengths }}</td>
            <td>{{ player.weaknesses }}</td>
            <td>{{ player.primary_class }}</td>
            <td>{{ player.primary_class_level }}</td>
            <td>{{ player.secondary_class }}</td>
            <td>{{ player.secondary_class_level }}</td>
            <td>{{ player.race }}</td>
            <td>{{ player.intelligence + player.magic_intelligence }}</td>
            <td>{{ player.constitution + player.magic_constitution }}</td>
            <td>{{ player.Dexterity + player.magic_Dexterity }}</td>
            <td>{{ player.strength + player.magic_strength }}</td>
            <td>{{ player.wisdom + player.magic_wisdom }}</td>
            <td>{{ player.charisma + player.magic_charisma }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
